import { render, staticRenderFns } from "./AlternateEnding.vue?vue&type=template&id=176baf68&scoped=true&"
import script from "./AlternateEnding.vue?vue&type=script&lang=js&"
export * from "./AlternateEnding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176baf68",
  null
  
)

export default component.exports